import { AxiosResponseHeaders } from 'axios';
import { SwiftCitiesResponseDTO, SwiftCity } from '../entities';

const swiftCitiesResponseDTOToSwiftCitiesResponseAdapter = (
  data: SwiftCitiesResponseDTO,
  headers?: AxiosResponseHeaders,
): SwiftCity[] => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body.swiftCityResponseDtoList.map(sc => new SwiftCity(sc.cityName));
};

export { swiftCitiesResponseDTOToSwiftCitiesResponseAdapter };
